import { command } from "../../app/command";
import { api } from "../../app/api";
import { EventPayload } from "../../common/types/Event";
import { Options } from "../../common/types/requestOptions";
import { DateValuePair } from "../talents/talentAPI";

export const changeAssignmentSupplementPriceOverrides = (
  data: ChangeOverrides,
  { requestId }: Options,
) => {
  return api
    .post<EventPayload<PriceOverridesChanged>[]>(
      "/working/cmd/chgAssignmentSupplementPriceOverrides",
      {
        requestId,
        body: {
          ...data,
        },
        auth: true,
      },
    )
    .then((res) => res.data);
};

export type PriceValueType =
  | "FIXED_PRICE"
  | "SALARY_PERCENTAGE"
  | "SALARY_MULTIPLIER";

export const priceListUnits: Record<PriceValueType, string> = {
  FIXED_PRICE: "€",
  SALARY_PERCENTAGE: "%",
  SALARY_MULTIPLIER: "%",
};

export interface TesPricingOverrideItems {
  [key: string]: {
    value: string;
    unit: PriceValueType;
  };
}

export interface TesPricingOverrideOptions {
  [key: string]: {
    unit: PriceValueType;
    unitValue: string;
  };
}

export interface SingleOverrideItem {
  key: string;
  value: string;
  unit: PriceValueType | "";
}

export interface ChangeOverrides {
  assignmentId: string;
  version: number;
  overrides: { [key: string]: string };
}
export interface PriceOverridesChanged {
  prices: { [key: string]: string };
}

export interface SupplementPriceOverrideSchedulePayload {
  unit: PriceValueType;
  values: DateValuePair[];
}

export interface AssignmentSupplementPriceOverridesChangedV2Payload {
  code: string;
  schedule: SupplementPriceOverrideSchedulePayload;
}

export interface ChangeAssignmentSupplementPriceScheduleCmd {
  assignmentId: string;
  version: number;
  code: string;
  values: DateValuePair[];
}

export const changeAssignmentSupplementPriceSchedule = (
  data: ChangeAssignmentSupplementPriceScheduleCmd,
  options: Options,
): Promise<EventPayload<AssignmentSupplementPriceOverridesChangedV2Payload>[]> =>
  command<
    ChangeAssignmentSupplementPriceScheduleCmd,
    AssignmentSupplementPriceOverridesChangedV2Payload
  >("/working/cmd/chgAssignmentSupplementPriceSched", data, options);
